import { ENV } from "../utils";

export class ContractType {
  baseApi = ENV.BASE_API;

  async getContractTypes(accessToken, active = true) {
    const url = `${this.baseApi}/contract-types?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createContractType(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-contract-type`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateContractType(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-contract-type/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteContractType(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-contract-type/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
